module.exports = __webpack_public_path__ + "static/media/441.f3a86e75.png";